export const smr3BetaSuperUsers = [
  // Production
  'jasper@boltenergie.be',
  'rens@boltenergie.be',

  // Staging
  'admin@boltenergie.be',
  'operator@boltenergie.be'
]
